// client/src/routes/app/properties/$propertyId/index.tsx — SCR-PROP-003 tab „General" · PROP-004.
//
// The layout above has already fetched the property; `useProperty` here is the same query key,
// so react-query serves it from cache rather than issuing a second request. Reading it again
// beats threading it through an Outlet context: each tab states what it needs, and a tab
// opened by direct URL works the same as one reached by clicking.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { GeneralTab } from '@/features/properties/GeneralTab';
import { useProperty } from '@/features/properties/queries';

export const Route = createFileRoute('/app/properties/$propertyId/')({
  component: GeneralTabScreen,
});

function GeneralTabScreen() {
  const { propertyId } = Route.useParams();
  const property = useProperty(propertyId);

  if (property.isPending) return <LoadingState rows={3} />;
  if (property.isError) return <ErrorState error={property.error} onRetry={() => void property.refetch()} />;

  return <GeneralTab property={property.data} />;
}
